import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Historia clínica armada en papel porque "la mía no era legal para Argentina"', 'Consentimientos copiados de internet que no cumplen la Ley 26.529', 'Protocolos de HTA, DBT2 y celiaquía en tres carpetas distintas que nunca encontrás', 'El paciente pregunta por creatina y buscás en Google mientras sonreís con cara de "ya lo sé"', 'El "¿y yo qué como?" sin respuesta clara todos los viernes a las 11 de la noche', 'Fin de semana agotado. El lunes, el mismo ciclo.'];
  return <section className="py-8 md:py-16 px-4 max-w-4xl mx-auto" data-id="element-248">
      <FadeIn data-id="element-249">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-3 md:mb-6 px-2" data-id="element-250">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="text-sm md:text-xl text-gray-300 text-center mb-5 md:mb-12 space-y-2.5 md:space-y-4 max-w-3xl mx-auto" data-id="element-251">
          <p data-id="element-252">
            Amás lo que hacés. Pero nadie te dijo que ibas a pasar los domingos
            armando formularios desde cero, buscando recetas que no encajan y
            redactando planes para patologías que ya conocés de memoria.
          </p>
          <p className="font-bold text-white text-lg md:text-2xl mt-4 md:mt-8" data-id="element-253">
            No es falta de vocación.{' '}
            <span className="text-red-400" data-id="element-254">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-255">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-256">
            <motion.div whileHover={{
          scale: 1.02,
          backgroundColor: 'rgba(127, 29, 29, 0.1)'
        }} className="bg-gray-900/50 border border-gray-800 rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start h-full transition-colors" data-id="element-257">
              <XCircle className="text-red-500 shrink-0 mt-0.5 drop-shadow-[0_0_8px_rgba(239,68,68,0.5)] w-5 h-5 md:w-6 md:h-6" data-id="element-258" />
              <span className="text-sm md:text-lg text-gray-300 leading-relaxed" data-id="element-259">
                {pain}
              </span>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-260">
        <div className="text-center relative" data-id="element-261">
          <div className="absolute inset-0 bg-green-500/10 blur-3xl rounded-full" data-id="element-262"></div>
          <motion.div animate={{
          y: [0, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 inline-flex flex-col items-center" data-id="element-263">
            <Sparkles className="text-green-400 mb-2 md:mb-4 w-6 h-6 md:w-8 md:h-8" data-id="element-264" />
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-300 via-green-400 to-emerald-500 drop-shadow-sm px-2" data-id="element-265">
              ¿Y si este fuera el último domingo que pasó así?
            </h3>
          </motion.div>
        </div>
      </FadeIn>
    </section>;
}